import React, { useState, useEffect } from 'react';
import MapUfs from "../../views/Dashboard/MapUfs";
import SummaryRegisteredData from "../../components/BeneficiaryDataLoader/SummaryRegisteredData/SummaryRegisteredData";
import { DimensionamentoService } from "../../services/DimensionamentoServices";

const CollaboratorsDistributionReport = () => {
  const [selectedCity, setSelectedCity] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedVariable, setSelectedVariable] = useState('total');
  const [tableLocked, setTableLocked] = useState(true);

  const [colaboradores, setColaboradores] = useState({
    valuesCity: [],
    valuesMacro: [],
    valuesMicro: []
  });

  useEffect(() => {
    const getColaboradores = async () => {
      try {
        const steps =
          'Dados Especialidades Médicas Ambulatoriais,' +
          'Profissionais Não Médicos Ambulatoriais';

        const citiesData = await DimensionamentoService.fetchCities();
        const uniqueStates = [...new Set(citiesData.map(c => c.state))].sort();

        const allData = await Promise.all(
          uniqueStates.map(state =>
            DimensionamentoService.getCollaborators(steps, state)
          )
        );

        const cityMap = new Map();

        allData.forEach(data => {
          const allAttributes = data.flatMap(step => step.attributeList || []);
          for (const attr of allAttributes) {
            if (attr.city) {
              const key = `${attr.city.city}-${attr.city.state}`;
              const value = attr.value ?? 0;

              if (!cityMap.has(key)) {
                cityMap.set(key, [
                  `${attr.city.city} - ${attr.city.state}`,
                  attr.city.state,
                  attr.city.macroRegiao,
                  attr.city.microRegiao,
                  value
                ]);
              } else {
                cityMap.get(key)[4] += value;
              }
            }
          }
        });

        const valuesCity = Array.from(cityMap.values());

        setColaboradores({
          valuesCity,
          valuesMacro: [...valuesCity],
          valuesMicro: [...valuesCity]
        });
      } catch (error) {
        console.error('Erro ao buscar colaboradores:', error);
        setColaboradores({ valuesCity: [], valuesMacro: [], valuesMicro: [] });
      }
    };

    getColaboradores();
  }, []);

  return (
    <div className="report-container grid grid-cols-1 xl:grid-cols-2 gap-2 w-full px-4 mx-auto mb-5 items-stretch">
      <div className="w-full h-[85vh] md:h-[80vh] flex flex-col border rounded-lg shadow-lg">
        <MapUfs
          beneficiariosDemo={colaboradores}
          regionInputDataSetter={setSelectedCity}
          selectedCity={selectedCity}
          setSelectedVariable={setSelectedVariable}
          search={search}
          setSearch={setSearch}
          setSelectedState={setSelectedState}
          selectedState={selectedState}
          tableSetter={setTableLocked}
          subTitle={"Mapa de Distribuição da Rede Prestadora por "}
        />
      </div>

      <div className="w-full h-[95vh] md:h-[80vh] flex flex-col border rounded-lg shadow-lg">
        <div className="flex flex-row py-6 px-12 justify-center items-center">
          <h1 className="text-xl">
            Colaboradores por <span className="text-emerald-700">Região</span>
          </h1>
        </div>
        <div className="flex-grow px-4 pb-4 overflow-y-auto">
          <SummaryRegisteredData
            beneficiaryData={colaboradores}
            selectedVariable={selectedVariable}
            selectedCity={selectedCity}
            tableLock={tableLocked}
            search={search}
            selectedState={selectedState}
            totalPopulationTitle={"Rede Prestadora Total"}
          />
        </div>
      </div>
    </div>
  );
};

export default CollaboratorsDistributionReport;
